import { render, staticRenderFns } from "./PlanNotesPlansTable.vue?vue&type=template&id=f5dfe138&scoped=true&lang=pug"
import script from "./PlanNotesPlansTable.vue?vue&type=script&lang=js"
export * from "./PlanNotesPlansTable.vue?vue&type=script&lang=js"
import style0 from "./PlanNotesPlansTable.vue?vue&type=style&index=0&id=f5dfe138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dfe138",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
